import script from "./AnimatedHands.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedHands.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedHands.vue?vue&type=style&index=0&id=7bad426a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bad426a"]])

export default __exports__